"use client";

import { useI18n } from "@/i18n";

const SITE = "GuineeMall";
const CONTACT_EMAIL = "18918855336@126.com";

const styles = {
  page: {
    minHeight: "100vh",
    background: "#F5F7F5",
    paddingTop: 96,
    paddingBottom: 80,
  },
  container: {
    maxWidth: 820,
    margin: "0 auto",
    padding: "0 24px",
  },
  card: {
    background: "#ffffff",
    borderRadius: 16,
    border: "1px solid #ECEEEC",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
    padding: "48px 56px",
  },
  title: {
    fontSize: 32,
    fontWeight: 800,
    color: "#111827",
    margin: 0,
    letterSpacing: "-0.01em",
  },
  subtitle: {
    fontSize: 14,
    color: "#6B7280",
    marginTop: 10,
    marginBottom: 32,
    paddingBottom: 24,
    borderBottom: "1px solid #F1F3F1",
  },
  section: { marginTop: 32 },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#111827",
    margin: "0 0 12px",
  },
  body: { fontSize: 15, lineHeight: 1.8, color: "#374151" },
  list: { margin: "8px 0 0", paddingLeft: 22 },
  listItem: { marginBottom: 6 },
  contactBox: {
    marginTop: 32,
    padding: "20px 24px",
    background: "#F4F6F4",
    borderRadius: 12,
    fontSize: 14,
    color: "#374151",
    lineHeight: 1.8,
  },
  highlight: {
    background: "#FFFBEB",
    borderLeft: "3px solid #F59E0B",
    padding: "14px 18px",
    borderRadius: 8,
    fontSize: 14,
    color: "#92400E",
    margin: "16px 0 0",
  },
};

function Section({ title, children }) {
  return (
    <section style={styles.section}>
      <h2 style={styles.sectionTitle}>{title}</h2>
      <div style={styles.body}>{children}</div>
    </section>
  );
}

export default function TermsPage() {
  const { t } = useI18n();
  const tt = (k) => t(`terms.${k}`);
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <article style={styles.card}>
          <h1 style={styles.title}>{t("footer.legal.terms")}</h1>
          <div style={styles.subtitle}>
            {t("privacyUi.updated")}：2026 · {t("footer.company")}
          </div>

          <div style={styles.highlight}>{tt("highlight")}</div>

          <Section title={tt("s1Title")}>
            <p>{tt("s1p1")}</p>
            <p>{tt("s1p2")}</p>
          </Section>

          <Section title={tt("s2Title")}>
            <ul style={styles.list}>
              {tt("s2list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          </Section>

          <Section title={tt("s3Title")}>
            <p>{tt("s3Intro")}</p>
            <ul style={styles.list}>
              {tt("s3list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          </Section>

          <Section title={tt("s4Title")}>
            <ul style={styles.list}>
              {tt("s4list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          </Section>

          <Section title={tt("s5Title")}>
            <ul style={styles.list}>
              {tt("s5list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          </Section>

          <Section title={tt("s6Title")}>
            <ul style={styles.list}>
              {tt("s6list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          </Section>

          <Section title={tt("s7Title")}>
            <ul style={styles.list}>
              {tt("s7list").map((item, i) => (
                <li key={i} style={styles.listItem}>{item}</li>
              ))}
            </ul>
          </Section>

          <Section title={tt("s8Title")}>
            <p>{tt("s8p1")}</p>
          </Section>

          <Section title={tt("s9Title")}>
            <p>{tt("s9p1")}</p>
          </Section>

          <Section title={tt("s10Title")}>
            <p>{tt("s10p1")}</p>
          </Section>

          <div style={styles.contactBox}>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>{tt("contactBoxTitle")}</div>
            <div>{tt("contactBoxMsg")}</div>
            <div style={{ marginTop: 8 }}>
              {tt("contactEmail")} <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: "#2F9E44" }}>{CONTACT_EMAIL}</a>
            </div>
            <div>{tt("contactOperator")} {t("footer.company")}</div>
          </div>
        </article>
      </div>
    </div>
  );
}
